import { Col, Form, Input, Row, DatePicker, Select, Button } from 'antd';
import type { FormInstance } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import CartApi from 'apis/CartApi';
import { useEffect, useState } from 'react';
import useCategoryManagementStore from 'store/categoryManagementStore';
import { useUser } from 'contexts/User';
import { useQuery } from 'react-query';
import PortfolioApi from 'apis/PortfolioApi';
import moment from 'moment';
import PofTypeApi from 'apis/PofTypeApi';
import DeclareCartPage from './DeclareCart';
import { ICartPost } from 'interface/cart.interface';

interface Iparam {
  id?: string;
}

export default function DeclareCartInfo(): JSX.Element {
  // const { id } = useParams<Iparam>();

  // const { currentData, id } = useLocation().state;
  const currentData = useLocation()?.state?.currentData || null;
  const id = useLocation()?.state?.id || null;

  const history = useHistory();
  const { user } = useUser();
  const { TextArea } = Input;
  const { Option } = Select;
  const [form] = Form.useForm();
  const dateFormat = 'DD/MM/YYYY';

  const setStep = useCategoryManagementStore((state) => state.setStep);

  const { data: lstPofType } = useQuery(['getAll'], () =>
    PofTypeApi.getCartType()
  );
  // const { data: porfolioDetail, isLoading } = useQuery(
  //   ['get'],
  //   () => PortfolioApi.getDetail(id || ''),
  //   { enabled: !!id }
  // );

  useEffect(() => {
    setStep(0);
    if (currentData) {
      // const values = porfolioDetail?.data;
      const values = currentData;
      if (values) {
        values.release_date = moment(values.release_date);
        values.expiration_date = moment(values.expiration_date);
        values.effective_date = moment(values.effective_date);
      }
      form.setFieldsValue(values);
    } else {
      form.setFieldsValue({
        pof_name: '',
        start_date: '',
        end_date: '',
        division_id: '',
        allow_order_ni: false,
        cht_approve_date: '',
        description: '',
      });
    }
  }, [form]);

  const validateMessages = {
    required: '${label} không được để trống!',
  };

  const [releaseDate, setReleaseDate] = useState(null);

  // const handleReleaseDateChange = (value) => {
  //   // Cập nhật giá trị ngày phát hành và reset giá trị ngày hết hạn
  //   setReleaseDate(value);
  // };

  const handleReleaseDateChange = (value: any, form: any) => {
    form.setFieldsValue({
      expiration_date: null,
    });
    setReleaseDate(value);
  };

  // const handleExpirationDateChange = (value: any, form: any) => {
  //   form.setFieldsValue({
  //     expiration_date: null,
  //   });
  //   setReleaseDate(value);
  // };

  const disabledDateExpiration = (current: any, form: any) => {
    const releaseDate = form.getFieldValue('release_date');
    return moment(releaseDate).add(1, 'days') > current;
  };

  const onNextStep = (values: any) => {
    if (currentData) {
      console.log('values: ', values);

      // params.id = id;
      CartApi.put({ ...values, id: currentData.id?.toString() }).then(
        (res: any) => {
          if (res.success) {
            // history.push(`/add-category/product-list-step/${currentData.id}`);
            history.push(
              `/declare-cart-product/${res.data.id}/${values.cart_type}`,
              { edit: true }
            );
          }
        }
      );
    } else {
      CartApi.post(values).then((res) => {
        console.log(res);
        if (res.success) {
          history.push(
            `/declare-cart-product/${res.data.id}/${values.cart_type}`
          );
        }
      });
    }
  };

  return (
    <DeclareCartPage>
      <Form
        form={form}
        layout="vertical"
        className="items-center"
        onFinish={onNextStep}
        autoComplete="off"
        validateMessages={validateMessages}
      >
        <Content>
          <div className="text-xl font-bold mb-6">1. Khai báo giỏ hàng</div>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Người tạo
                </Col>
                <Col className="" span={12}>
                  : {user?.fullName}
                </Col>
              </Row>
            </Col>
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Email
                </Col>
                <Col className="" span={12}>
                  : {user?.email}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-2">
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Khối phát hành
                </Col>
                <Col className="" span={12}>
                  : {user?.division}
                </Col>
              </Row>
            </Col>
            <Col className="" span={12}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="" span={6}>
                  Công ty phát hành
                </Col>
                <Col className="" span={12}>
                  : {user?.organization}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={3}>
              Đơn vị phát hành
            </Col>
            <Col className="" span={20}>
              : {user?.departmentName}
            </Col>
          </Row>

          <div className="my-4 border-2 border-dashed border-neutral-90"></div>

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={12}>
              <Form.Item
                name="cart_name"
                label="Tên giỏ hàng"
                rules={[{ required: true }]}
              >
                <Input placeholder="Nhập tên giỏ hàng" className="" />
              </Form.Item>
            </Col>
            <Col className="" span={12}>
              <Form.Item
                name="cart_type"
                label="Loại giỏ hàng"
                rules={[{ required: true }]}
              >
                <Select placeholder="Chọn">
                  {lstPofType?.data?.map((item) => (
                    <Option value={item.pof_type_code} key={item.id}>
                      {item.pof_type_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={12}>
              <Form.Item
                rules={[{ required: true }]}
                name="release_date"
                label="Ngày phát hành"
              >
                <DatePicker
                  placeholder="dd/mm/yyyy"
                  className="ant-input"
                  format={dateFormat}
                  disabledDate={(current) => {
                    return moment().add(-1, 'days') > current;
                  }}
                  onChange={(value) => handleReleaseDateChange(value, form)}
                />
              </Form.Item>
            </Col>
            <Col className="" span={12}>
              <Form.Item
                rules={[{ required: true }]}
                name="expiration_date"
                label="Ngày hết hạn"
              >
                <DatePicker
                  placeholder="dd/mm/yyyy"
                  className="ant-input"
                  format={dateFormat}
                  disabledDate={
                    (current: any) => {
                      const releaseDate = form.getFieldValue('release_date');
                      return releaseDate >= current;
                    }
                    // disabledDateExpiration(current, form)
                  }
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={12}>
              <Form.Item
                rules={[{ required: true }]}
                name="effective_date"
                label="Ngày hiệu lực"
              >
                <DatePicker
                  placeholder="dd/mm/yyyy"
                  className="ant-input"
                  format={dateFormat}
                  disabledDate={(current: any) => {
                    return moment().add(-1, 'days') > current;
                  }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={24}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px',
                }}
              >
                <Form.Item
                  rules={[{ required: false }]}
                  name="description"
                  label="Mô tả giỏ hàng"
                  className="mb-0"
                >
                  <TextArea
                    required={false}
                    maxLength={500}
                    rows={4}
                    showCount
                    placeholder="Nhập mô tả"
                    style={{ marginRight: '10px' }}
                  />
                </Form.Item>
              </div>
            </Col>
          </Row>
        </Content>
        <Row
          className="mt-8"
          gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
          justify="end"
        >
          <Col className="flex justify-end gap-2.5" span={8}>
            <Form.Item className="mr-2">
              <Button
                onClick={() => history.push('/cart-list')}
                className="border-solid border border-primary-50 px-5 py-3 text-base h-12"
              >
                <span className="text-primary-50">Trở lại</span>
              </Button>
            </Form.Item>
            <Form.Item>
              <Button
                className="py-3 px-5 h-12 rounded-lg text-white bg-primary-50"
                type="primary"
                htmlType="submit"
              >
                <span className="text-base font-normal">Tiếp theo</span>
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </DeclareCartPage>
  );
}
